import ActionTypes from "./ActionTypes";
import InteractionTypes from "./InteractionTypes";

const FeatureType = 'Lexile';

const LexileMeasureEventTypes = {
	LEXILE_VIEWCHART_CLICKED: {
		featureClick: {
			name: "LexileInfo"
		},
		interaction: {
			name: 'Lexile: View Chart - clicked',
			actionType: ActionTypes.INLINE_DISPLAY,
			interactionType: InteractionTypes.UX_ACTION,
			featureType: FeatureType
		}
	},
	LEXILE_NOVELIST_CLICKED: {
		featureClick: {
			name: "LexileLinkToNoveList"
		},
		interaction: {
			name: 'Lexile: NoveList - clicked',
			actionType: ActionTypes.P_LINK,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: FeatureType
		}
	},
	LEXILE_SEARCH_CLICKED: {
		featureClick: {
			name: "LexileSearch"
		},
		interaction: {
			name: 'Lexile: Search - clicked',
			actionType: ActionTypes.SEARCH,
			interactionType: InteractionTypes.UX_ACTION,
			featureType: FeatureType
		}
	},
	LEXILE_TITLE_CLICKED: { 
		featureClick: {
			name: "LexileSearchResults"
		},
		interaction: {
			name: 'Lexile: Title - clicked',
			actionType: ActionTypes.CATALOG_LINK,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: FeatureType
		}
	},
	LEXILE_COVER_CLICKED: {
		featureClick: {
			name: "LexileSearchResults"
		},
		interaction: {
			name: 'Lexile: Cover - clicked',
			actionType: ActionTypes.CATALOG_LINK,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: FeatureType
		}
	},
	LEXILE_FINDIT_CLICKED: {
		featureClick: {
			name: "LexileSearchResults"
		},
		interaction: {
			name: 'Lexile: Find It - clicked',
			actionType: ActionTypes.CATALOG_LINK,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: FeatureType
		}
	},
	LEXILE_AVAILABILITY_CLICKED: {
		featureClick: {
			name: "ots"
		},
		interaction: {
			name: 'Lexile: Availability - clicked',
			actionType: ActionTypes.INLINE_DISPLAY,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: FeatureType
		}
	}
};

export default LexileMeasureEventTypes;



// WEBPACK FOOTER //
// ./src/data/types/LexileMeasureEventTypes.js